import type { IResponseCreateInvitesError } from 'entities/Users/api/types'

type ErrorData = IResponseCreateInvitesError & {
  message?: string
  error?: string
  [key: string]: unknown
}

export const parseInvitesError = (errorData: ErrorData): string | null => {
  const errorMessages: string[] = []

  for (const key in errorData) {
    const value = errorData[key]

    if (Array.isArray(value)) {
      const stringMessages = value.filter((item): item is string => typeof item === 'string')
      errorMessages.push(...stringMessages)
    } else if (typeof value === 'string' && value.trim()) {
      errorMessages.push(value)
    }
  }

  return errorMessages.length > 0 ? errorMessages.join(', ') : null
}
